import { Component, HostListener, OnDestroy, OnInit, signal, ViewEncapsulation } from '@angular/core'
import { TableColumn } from 'src/app/components/common/common-table/common-table.component'
// import { WorkflowJanusStatusPillComponent } from './workflow-janus-status-pill.component'
import { WorkflowJanusActionsComponent } from './workflow-janus-actions/workflow-janus-actions.component'
import { NewWorkflowDialogComponent } from './new-workflow-dialog/new-workflow-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ClientService, SecurityService, WorkflowContextService, WorkflowService, WorkflowValidationService } from 'src/app/services';
import { filter, map } from 'rxjs/operators';
import { Actions, Client, Workflow, WorkflowCheckpoint, WorkflowConfigurationSaveListItem, WorkflowType } from 'src/app/models';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WorkflowJanusService } from './workflow-janus.service';
import { ToastrService } from 'ngx-toastr';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { StartApplicationResponse } from 'src/app/models/start-application-response';
import { WorkflowJanusPendingActionsComponent } from './workflow-janus-pending-actions/workflow-janus-pending-actions.component';
import { ClickableCellComponent } from 'src/app/components/common/common-table/clickable-cell/clickable-cell.component';
import { WorkflowViewDetailsComponent } from './workflow-view-details/workflow-view-details.component';
import { CommonDropdownData } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { ValidationSeverity } from 'src/app/models/validation';
import { ImportWorkflowModalDataComponent } from './use-template-workflow/use-template-actions/import-workflow-modal/import-workflow-modal.component';
import { WorkflowJanusStatusPillComponent } from './workflow-janus-status-pill/workflow-janus-status-pill.component';

@Component({
  selector: 'app-workflow-janus',
  standalone: false,
  templateUrl: './workflow-janus.component.html',
  styleUrls: ['./workflow-janus.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkflowJanusComponent implements OnInit, OnDestroy{
  selectedWorkflowSave: WorkflowConfigurationSaveListItem;
  loading = signal(true);
  workflowsLoading = signal(true);
  archivedLoading = signal(true);
  pendingLoading = signal(true);
  columns: TableColumn[] = [];
  pendingColumns: TableColumn[] = [];
  data: any[] = [];
  workflows$ = this.workflowJanusService.workflows$;
  archivedWorkflows$ = this.workflowJanusService.archivedWorkflows$;
  pendingWorkflows$ = this.workflowJanusService.pendingWorkflows$;
  activeTab: 'list' | 'archive' | 'pending' = 'list';
  selectedIndex = 0;
  newWorkflowBtnDisable = false; // added by Vipul on 24-06-2026

  listTabLoader = false;
  archiveTabLoader = false;
  pendingTabLoader = false;

  workflows: Workflow[];
  archivedWorkflows: Workflow[];
  loadGlobal = false;
  clientSub: Subscription;
  canCreateWorkflow: boolean;
  canCreateFromTemplate: boolean;
  workflowTypes: WorkflowType[] = [];
  selectedWorkflow: Workflow | null = null;
  workflowViewDetailsComponent = WorkflowViewDetailsComponent; // added by Vipul on 27-03-2026

  isSysAdmin = false;

  isEntitledToDisable: boolean;
  isEntitledToPublish: boolean;
  isEntitledToHistory: boolean;
  isEntitledToBuilder: boolean;
  isEntitledToStart: boolean;
  isEntitledToArchive: boolean;

  clients: Client[];

  jurisdictionData: CommonDropdownData;
  //added by Vipul on 04/19/2026
  changingTargetClient = false;
  firstTargetClientSelectionMade = false;
  //end by Vipul on 04/19/2026

  searchText: string = '';
  filteredWorkflows: any[] = [];
  workflowsSnapshot: any[] = [];

  tableHeight = '330px'; // added by Vipul on 24-06-2026

  // Confirmation Modal
  disableConfirmModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'default',
  };
  disableReason: string;

  copyConfirmModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'info',
    replaceYesWith: 'COPY',
    replaceNoWith: 'CANCEL',
  };

  copyChoiceModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'info',
    replaceYesWith: 'ANOTHER JURISDICTION',
    replaceNoWith: 'THIS JURISDICTION',
    modalWidth: '480px',
    modalHeight: '240px',
    customClass: 'copy-choice-modal' // Code added by Sanchit on 05/04/2026

  };

  addJurisdictionModal: CommonConfirmationModalData = {
    open: false,
    status: 'info',
    modalDescp: 'Add Jurisdiction',
    modalWidth: 'auto', //Edited by Sanchit on 04/29/2026
  }

  copyWorkflowId: string;
  targetName: string;
  targetClientId?: string;
  targetClientId1?: string; //added by Vipul on 04/19/2026
  copyingWorkflow = false;

  archiveModalData: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'error',
    modalWidth: 'auto', //Edited by Sanchit on 04/29/2026
  };
  archiveReason: string;
  archiveWorkflowName: string;

  publishModalData: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'error',
    modalWidth: 'auto', //Edited by Sanchit on 04/29/2026
  };
  publishReason: string;
  publishWorkflowName: string;
  isValidating: boolean = false;
  hasErrors: boolean = false;
  hasWarnings: boolean = false;
  warningMessages: string[] = [];

  workflowCheckpointsModal: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Workflow Checkpoints',
    status: 'info',
    modalWidth: 'auto', //Edited by Sanchit on 04/29/2026
  }
  checkpoints: WorkflowCheckpoint[];
  restoreId: string;
  cleanupHistoryModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Cleanup History',
    modalSubDescp: '',
    yesNoBtn: true,
    okBtn: true,
    status: 'error'
  };

  denyStartAppModal: CommonConfirmationModalData = {
    open: false
  }

  deleteConfirmModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'default'
  };

  departmentId: string; // added by Vipul on 16-04-2026
  appViewLoading: boolean = false;

  ngOnDestroy() {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
  }

  constructor(
    private dialog: MatDialog,
    private workflowJanusService: WorkflowJanusService,
    public _context: WorkflowContextService,
    private _workflowSvc: WorkflowService,
    private toastr: ToastrService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _securitySvc: SecurityService,
    private _workflowValidationSvc: WorkflowValidationService,
    private _clientSvc: ClientService
  ) { }

workflowsLoaded = false;
  _loadWorkflows() {
   this.workflowsLoading.set(true);
  this.workflowsLoaded = false;

  this._route.parent?.parent?.paramMap.subscribe(params => {
    this.departmentId = params.get('departmentId');
    this._workflowSvc
      .getWorkflows(this._context.client, false, this.loadGlobal, this.workflowTypes, this.departmentId)
      .pipe(
        map(res => {
          this.workflows = res;
          this.workflowJanusService.setWorkflows(this.workflows);

            this.workflowsLoaded = true;
        this.workflowsLoading.set(false);
        })
      ).subscribe();
    });

  }
  archivedLoaded = false;

  _loadArchivedWorkflows() {
     this.archivedLoading.set(true);
  this.archivedLoaded = false;
    return this._workflowSvc
      .getWorkflows(this._context.client, true, this.loadGlobal, this.workflowTypes)
      .subscribe(res => {
        this.archivedWorkflows = res.filter(w => w.isArchived);
        this.workflowJanusService.setArchivedWorkflows(this.archivedWorkflows);

        this.archivedLoaded = true;
      this.archivedLoading.set(false);
      });
  }

  loadWorkflows() {
    this.workflowJanusService.clear();
    this._loadWorkflows();
  }

  createWorkflow() {
    this._router.navigate(
      this.loadGlobal
        ? ['admin', 'global', 'workflows', 'add']
        : ['admin', 'jurisdiction', this._context.client.id, 'workflows', 'add']
    );
  }

  isSystemAdmin() {
    this._securitySvc.isSystemAdministrator().subscribe(result => {
      this.isSysAdmin = result;
    });
  }

  init() {
    this._securitySvc
      .isLoginEntitled(Actions.WORKFLOW_ADD)
      .subscribe(result => {
        this.canCreateWorkflow = result;
    });

    // check if the user can create a workflow from a template
    this._securitySvc.isLoginEntitled(Actions.NEW_WORKFLOW_FROM_TEMPLATE)
      .subscribe(result => {
        this.canCreateFromTemplate = result;
    });

    this._route.url.subscribe(url => {
      const path = url[0]?.path || 'list';

      this.activeTab = path as any;
      if (this.activeTab === 'list' && this.listTabLoader === false) {
        this.listTabLoader = true;
        this.archiveTabLoader = false;
        this.pendingTabLoader = false;
        this.loadWorkflows();
      } else if (this.activeTab === 'archive' && this.archiveTabLoader === false) {
        this.listTabLoader = false;
        this.archiveTabLoader = true;
        this.pendingTabLoader = false;
        this._loadArchivedWorkflows();
      } else if (this.activeTab === 'pending' && this.pendingTabLoader === false) {
        this.listTabLoader = false;
        this.pendingTabLoader = true;
        this.archiveTabLoader = false;
        this.getPendingWorkflows();
      }
    });
  }

  ngOnInit() {
    this.setupColumns();
    this.setupPendingColumns();

    this.isSystemAdmin();

    this.workflows$.subscribe(data => {
      this.workflowsSnapshot = data || [];
    });

    this.workflowJanusService.newWorkflowBtnDisabled$
    .subscribe(disabled => {
      this.newWorkflowBtnDisable = disabled;
    });

    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateNewWorkflowButton());

    this._route.data.subscribe(d => {
      this.loadGlobal = d.loadGlobal;

      this.workflowTypes = !this.loadGlobal
      ? [
        WorkflowType.Permit,
        WorkflowType.Other,
        WorkflowType.Renewable,
        WorkflowType.MobileInspection
      ]
      : [
        WorkflowType.ContractorRegistration,
        WorkflowType.ContractorRenewal
      ];

      if ((this._context && this._context.client) || this.loadGlobal) {
        this.init();
      } else {
        this.clientSub = this._context.client$.subscribe(() => {
          if (this._context.client) {
            this.init();
          }
        });
      }
    });

    this._route.url.subscribe(url => {
      const path = url[0]?.path || 'list';

      this.activeTab = path as any;

      switch (path) {
        case 'archive':
          this.selectedIndex = 1;
          break;
        case 'pending':
          this.selectedIndex = 2;
          break;
        default:
          this.selectedIndex = 0;
      }
    });

    this.workflowJanusService.action$
      .subscribe(event => {
        if (!event) return;

        this.onAction(event); // ✅ reuse existing logic
        this.workflowJanusService.clearAction(); //start by Vipul on 23-06-2026
      });

    this.buildPermissions();

    this._clientSvc.getAdminClients().subscribe(clients => {

      this.clients = clients.filter(c => c.id !== this._context?.client?.id);

      this.clients.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      )

      this.buildAddJurisdictionDropdown();
    });

    const nav = this._router.getCurrentNavigation();
    this.appViewLoading = nav?.extras?.state?.['appViewLoading'];

  }

  onTabChange(index: number) {
    const routes = ['list', 'archive', 'pending'];

    this._router.navigate(
      [routes[index]],
      { relativeTo: this._route.parent }
    );
  }

  canDisable(wf: Workflow): boolean {
    return (
      !wf.isArchived &&
      wf.isEnabled &&
      this.isEntitledToDisable === true
    );
  }
  canEnable(wf: Workflow): boolean {
    return (
      !wf.isArchived &&
      !wf.isEnabled &&
      this.isEntitledToDisable === true
    );
  }
  canStartApplication(): boolean {
    if (!this.selectedWorkflow) return false;

    return (
      (!this.selectedWorkflow.isArchived &&
        this.selectedWorkflow.isEnabled &&
        this.selectedWorkflow.isPublished) ||
      (this.selectedWorkflow.lastPublishedOnString && this.isEntitledToPublish === true)
    );
  }
  canArchiveWorkflow(wf: Workflow): boolean {
    return !wf.isArchived && this.isEntitledToArchive === true;
  }
  canRestoreWorkflow(): boolean {
    return this.selectedWorkflow.isArchived;
  }
  canPublish(wf: Workflow): boolean {
    return (
      wf.isEnabled &&
      wf.areThereChangesNotPublished &&
      this.isEntitledToPublish === true
    );
  }

  openPublishConfirmation(wf: Workflow) {
    this.selectedWorkflow = wf;
    this.publishReason = '';
    this.publishWorkflowName = wf.version.name;

    this.publishModalData = {
      open: true,
      modalDescp: 'Publish Workflow',
      yesNoBtn: true,
      status: 'error',
      replaceYesWith: 'PUBLISH',
      replaceNoWith: 'CANCEL',
      customClass: 'publish-workflow-modal publish-disabled'
    };

    this.validateWorkflow(wf);
  }

  onPublishReasonChange() {
    this.updatePublishModalState();
  }

  updatePublishModalState() {
    this.publishModalData = {
      ...this.publishModalData,
      customClass: this.isPublishDisabled()
        ? 'publish-workflow-modal publish-disabled'
        : 'publish-workflow-modal'
    };
  }

  isPublishDisabled(): boolean {
    return this.isValidating || this.hasErrors || !this.publishReason?.trim();
  }

  async validateWorkflow(wf: Workflow) {
    this.isValidating = true;
    this.hasErrors = false;
    this.hasWarnings = false;
    this.warningMessages = [];

    const validationResults = await this._workflowValidationSvc
      .validate(wf.id, true, true)
      .then();

    const validityErrors = [];
    const validityWarnings = [];

    for (const item of validationResults) {
      const errors = item.messages.filter(m => m.severity === ValidationSeverity.Error);
      const warnings = item.messages.filter(m => m.severity === ValidationSeverity.Warning);

      if (errors.length > 0) {
        validityErrors.push(item);
      }
      if (warnings.length > 0) {
        validityWarnings.push(...warnings.map(w => w.message));
      }
    }

    this.isValidating = false;
    this.hasErrors = validityErrors.length > 0;
    this.hasWarnings = validityWarnings.length > 0;
    this.warningMessages = validityWarnings;

    // Reactively refresh the modal configuration attributes whenever validation completes
    this.updatePublishModalState();

    this.workflowJanusService.setData({
      ...this.workflowJanusService.getData(),
      isWorkflowValid: !this.hasErrors
    });
  }

  onPublishConfirmed() {
    if (this.isPublishDisabled()) return;

    // Specifically block standard critical errors but safely bypass warnings
    if (!this.hasErrors) {
      this._workflowSvc.publishWorkflow(this.selectedWorkflow.id, this.publishReason).subscribe(res => {
        this.toastr.success('Published!');
        this.publishModalData.open = false;
        this.publishReason = '';
        this.selectedWorkflow = null;
        this.loadWorkflows();
      });
    } else {
      this.selectedWorkflow = null;
      this.publishReason = '';
      this.publishModalData.open = false;
      this.toastr.error('Workflow contains errors and cannot be published.');
    }
  }

  canViewHistory(wf: Workflow): boolean {
    return this.isEntitledToHistory === true;
  }
  canEditWorkflow(wf: Workflow): boolean {
    return this.isEntitledToBuilder == true && !wf.isArchived;
  }

  openNewWorkflowDialog(): void {
    this.workflowJanusService.setNewWorkflowButtonDisabled(true); // added by Vipul on 24-06-2026
    const dialogRef = this.dialog.open(NewWorkflowDialogComponent, {
      width: '720px',
      maxWidth: '90vw',
      panelClass: 'new-workflow-dialog',
      disableClose: true,
      data: {
        context: this._context
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      if (result.action === 'blank') {
        this.createWorkflow();
      }
    });
  }

  handleAction = (event: { action: string; row: any }) => {
    this.onAction(event);
  };

  setupColumns(): void {
    this.columns = [
      {
        key: 'name',
        label: 'Name',
        hideMenu: true,
        headerType: 'text',
        cellType: 'component',
        textColor: '#2196F3',
        component: ClickableCellComponent,
        componentInputs: row => ({
          text: row.name,
          row: row
        }),
        componentOutputs: {
          clicked: rowData => this.onNameClick(rowData)
        }
      },
      {
        key: 'lastPublished',
        label: 'Last Published',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'status',
        label: 'Status',
        hideMenu: true,
        headerType: 'text',
        cellType: 'component',
        component: WorkflowJanusStatusPillComponent,
        componentInputs: (row) => ({ row })
      },
      {
        key: 'actions',
        label: 'Actions',
        hideMenu: true,
        headerType: 'text',
        cellType: 'component',
        component: WorkflowJanusActionsComponent,
        componentInputs: (row) => ({
          row: row.raw,
          isEntitledToDisable: this.canDisable(row.raw),
          isEntitledToPublish: this.canPublish(row.raw),
          isEntitledToHistory: this.canViewHistory(row.raw),
          isEntitledToBuilder: this.canEditWorkflow(row.raw),
          isEntitledToStart: true,
          isEntitledToArchive: this.canArchiveWorkflow(row.raw)
        }),
        componentOutputs: {
          action: this.handleAction
        }
      }
    ];
  }

  setupPendingColumns(): void {
    this.pendingColumns = [
      {
        key: 'sourceWorkflowName',
        label: 'Name',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'createdBy',
        label: 'Created By',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'modifiedBy',
        label: 'Last Saved By',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'detailedAction',
        label: 'Action',
        hideMenu: true,
        headerType: 'text',
        cellType: 'component',
        component: WorkflowJanusPendingActionsComponent,
        componentInputs: (row) => ({
          row: row.raw,
          context: this._context,
        }),
        componentOutputs: {
          action: this.handleAction
        }
      }
    ];
  }

  enableWorkflow(wf: Workflow) {
    this._workflowSvc.enableWorkflow(wf.id).subscribe(res => {
      this.toastr.success('Enabled!');
      this.loadWorkflows();
    });
  }
  openDisableConfirmationModal(wf: Workflow) {
    this.selectedWorkflow = wf;
    this.disableReason = '';
      this.disableConfirmModal = {
        open: true,
        modalDescp: 'Disable Workflow',
        modalSubDescp: `Are you sure you want to disable "${this.selectedWorkflow.version.name}"?`,
        replaceYesWith: 'DISABLE',
        replaceNoWith: 'CANCEL'
      };
  }
  onDisableConfirmation() {
    this._workflowSvc.disableWorkflow(this.selectedWorkflow.id).subscribe(() => {
      this.toastr.success('Disabled!');
      this.disableConfirmModal.open = false;
      this.loadWorkflows();
    });
  }

  openArchiveConfirmation(wf: Workflow) {
    this.selectedWorkflow = wf;
    this.archiveReason = '';
    this.archiveWorkflowName = wf.version.name;

    this.archiveModalData = {
      open: true,
      modalDescp: 'Archive Workflow',
      modalSubDescp: 'Are you sure you want to archive this workflow?',
      yesNoBtn: true,
      status: 'error',
      replaceYesWith: 'ARCHIVE',
      replaceNoWith: 'CANCEL'
    };
  }
  onArchiveConfirmed() {
    this._workflowSvc
      .archiveWorkflow(this.selectedWorkflow.id, this.archiveReason)
      .subscribe(() => {
        this.toastr.success('Workflow Archived');
        this.archiveModalData.open = false;
        this.archiveReason = '';
        this.selectedWorkflow = null;
        this.loadWorkflows();
      });
  }
  restoreWorkflow(wf: Workflow) {
    this.selectedWorkflow = wf;
    this._workflowSvc.restoreWorkflow(this.selectedWorkflow.id).subscribe(res => {
      this.toastr.success('Workflow restored!');
      this.selectedWorkflow = null;
      // Start Code added by Sanchit on 06/19/2026
      // Refresh both tabs
      this._loadWorkflows();
      this._loadArchivedWorkflows();
      // End Code added by Sanchit on 06/19/2026
    });
  }

  openWorkflowCheckpointsConfirmation(wf: Workflow) {
    this.selectedWorkflow = wf;
    this.loadHistory(wf);
    this.workflowCheckpointsModal = {
      open: true,
      closeBtn: true,
      modalDescp: 'Workflow Checkpoints',
      status: 'info',
      modalWidth: 'auto', //Edited by Sanchit on 04/29/2026
    }
  }
  loadHistory(wf: Workflow) {
    this._workflowSvc
      .getWorkflowCheckpoints(wf.id)
      .subscribe(res => {
        this.checkpoints = res;
      });
  }
  openCleanupHistoryModal() {
    return {
      text: 'CLEANUP HISTORY',
      onClick: () => {
        this.cleanupHistoryModalData = {
          ...this.cleanupHistoryModalData,
          modalSubDescp: `This will cleanup all of the "Auto" checkpoints for this workflow. Are you sure you want to cleanup the history of this workflow (${this.selectedWorkflow.version.name}).`,
          open: true,
          replaceYesWith: 'CLEANUP HISTORY',
          replaceNoWith: 'CANCEL',
          replaceOkWith: 'RESTORE',
        };
      }
    }
  }

  confirmCleanupHistory() {
    if (!this.selectedWorkflow) return;
    this._workflowSvc.cleanupWorkflowHistory(this.selectedWorkflow.id).subscribe(() => {
      this.toastr.success('Autosave History cleared');
      this.closeCleanupHistoryModal();
      this.loadWorkflows();
    });
  }
  closeCleanupHistoryModal() {
    this.cleanupHistoryModalData = {
      ...this.cleanupHistoryModalData,
      open: false
    };
    this.workflowCheckpointsModal.open = false;
    this.selectedWorkflow = null;
  }
  isRestoring(id: string): boolean {
    return this.restoreId === id;
  }
  restoreVersion(id: string) {
    this.restoreId = id;
    this._workflowSvc.restoreWorkflowCheckpoint(id).subscribe(res => {
      this.restoreId = null;
    });
  }
  openHistory(wf: Workflow) {
    this._router.navigate([
      '/admin',
      'workflow-history',
      wf.id
    ]);
  }

  startWorkflowCopy(wf: Workflow) {
    this.copyWorkflowId = wf.id;
    this.targetName = `Copy Of - ${wf.version.name}`;

    if (this.isSysAdmin && this._context.client) {
      this.copyChoiceModal = {
        ...this.copyChoiceModal,
        open: true,
        modalDescp: 'Copy Workflow',
        modalSubDescp: 'Where would you like to copy the Workflow to?'
      };
    } else {
      this.openCopyNameModal();
    }
  }

  onCopyFinished() {
    this.addJurisdictionModal = {
      ...this.addJurisdictionModal,
      open: false
    };

    this.copyChoiceModal = {
      ...this.copyChoiceModal,
      open: false
    };
    this.copyWorkflowId = null;
    this.targetClientId1 = null;

    this.loadWorkflows();
  }

  openCopyNameModal() {
    if (this._context.client) {
      this.targetClientId = this._context.client.id;
    }
    this.copyConfirmModal = {
      open: true,
      modalDescp: 'Copy Workflow',
      modalSubDescp: 'Enter a new name for the copied workflow',
      yesNoBtn: true,
      status: 'info',
    };
  }

  openAddJurisdictionModal() {
    if (this._context.client) {
      this.targetClientId = this._context.client.id;
    }
    this.addJurisdictionModal = {
      ...this.addJurisdictionModal,
      open: true
    };
  }

  onCopyChoiceYes() {
    this.copyChoiceModal.open = false;
    //added by Vipul on 04/19/2026
    setTimeout(() => {
      this.openAddJurisdictionModal();
    }, 0);
    //end by Vipul on 04/19/2026
  }

  onCopyConfirmOk() {
    this.copyingWorkflow = true;

    this._workflowSvc.copyWorkflow({
      workflowId: this.copyWorkflowId,
      targetClientId: this.targetClientId,
      targetName: this.targetName
    }).subscribe(newWorkflow => {
      this.copyingWorkflow = false;
      this.toastr.success('Workflow Copied');
      this.loadWorkflows();
    });
  }
  onCopyChoiceNo() {
    this.copyChoiceModal.open = false;
    this.openCopyNameModal();
  }

  hideWorkflow() {
    this._workflowSvc
      .hideWorkflowFromPublic(this.selectedWorkflow.id)
      .subscribe(result => {
        if (result) {
          this.selectedWorkflow.visibleToPublic = false;
          this.toastr.success('Workflow is no longer Visible to public');
          this.selectedWorkflow = null;
        }
      });
  }
  makeWorkflowVisible() {
    this._workflowSvc
      .makeWorkflowVisibleToPublic(this.selectedWorkflow.id)
      .subscribe(result => {
        if (result) {
          this.selectedWorkflow.visibleToPublic = true;
          this.toastr.success('Workflow is now Visible to public');
          this.selectedWorkflow = null;
        }
      });
  }
  toggleVisibleToPublic(wf: Workflow) {
    this.selectedWorkflow = wf;
    if (this.selectedWorkflow.visibleToPublic) {
      this.hideWorkflow();
    } else {
      this.makeWorkflowVisible();
    }
  }

  startApplication(wf: Workflow) {
    this.selectedWorkflow = wf;
    this._workflowSvc
      .getRenewableParentIds(this.selectedWorkflow.id)
      .subscribe(response => {
        if (response.renewableParentIds.length > 0) {
          this.denyStartAppModal.open = true;
        } else {
          this._workflowSvc
            .startApplication(this.selectedWorkflow.id, false)
            .subscribe((response: StartApplicationResponse) => {
              const startingActivityId = '1';

              const applicationId =
                response?.applicationId;

              if (!applicationId) {
                return;
              }

              const activeTab =
              this._route.snapshot.firstChild?.url?.[0]?.path || 'data';

              const segments = this._router.routerState.snapshot.url.split('/').slice(0, -2);
              if (segments.length == 6) {
                this._router.navigate([
                  ...segments,
                  'workflow-applications',
                  activeTab,
                  'application',
                  applicationId], {
                  relativeTo: this._route,
                  state: {
                    startingActivityId,
                    useNewLayout: this._context.useNewLayout
                  }
                });
              } else if (segments.length == 7) {
                const tempSeg = segments.slice(0, -1);

                this._router.navigate([
                  ...tempSeg,
                  'workflow-applications',
                  'data',
                  'application',
                  applicationId], {
                  relativeTo: this._route,
                  state: {
                    startingActivityId,
                    useNewLayout: this._context.useNewLayout
                  }
                });
              }
              setTimeout(() => {
                this._context.applicationViewType$.emit('overlay');
              }, 1000);
            });
        }
      });
  }

  buildPermissions() {
    if (this.selectedWorkflow) {
      this._securitySvc
        .isLoginEntitled(
          Actions.WORKFLOW_EDIT,
          this.selectedWorkflow,
          null,
          this.loadGlobal
        )
        .subscribe(result => {
          this.isEntitledToBuilder = result;
          this.isEntitledToPublish = result;
          this.isEntitledToDisable = result;
          this.isEntitledToHistory = result;
          this.isEntitledToArchive = result;
          this.isEntitledToStart = true;
        });
    }

    this._securitySvc.isLoginEntitled(Actions.DO_ANYTHING).subscribe(result => this.isSysAdmin = result);
  }
  pendingLoaded = false;

  getPendingWorkflows() {
    this.pendingLoading.set(true);
    this.pendingLoaded = false;

    this._workflowSvc
      .getPendingWorkflows(this._context.client.id)
      .subscribe(workflowSaves => {
        this.workflowJanusService.setPendingWorkflows(workflowSaves ?? []);
        this.pendingLoaded = true;
        this.pendingLoading.set(false);

      });
  }

  resumePendingWorkflow(row: any): void {
    this.dialog.open(ImportWorkflowModalDataComponent, {
      width: '80vw', // Code edited by Sanchit on 06/22/2026
      maxWidth: '900px', // Code edited by Sanchit on 06/22/2026
      height: '80vh', // Code edited by Sanchit on 06/22/2026

      data: {
        sourceWorkflowId: row.sourceWorkflowId,
        targetJurisdictionId: row.targetJurisdictionId,

        // THIS IS THE IMPORTANT PART
        workflowSaveId: row.id // Code edited by Sanchit on 06/22/2026
      }
    });
  }

  openDeleteConfirmationModal(workflowSave: any) {
    this.selectedWorkflowSave = workflowSave;
    this.deleteConfirmModal = {
      open: true,
      modalDescp: 'Delete Pending Workflow',
      modalSubDescp: `This will clear out the configuration for this pending workflow copy/import.`,
      replaceYesWith: 'YES',
      replaceNoWith: 'CANCEL'
    };
  }
  deletePending() {
    this.loading.set(true);

    this._workflowSvc.deletePendingWorkflow(this.selectedWorkflowSave.id)
      .subscribe(result => {
        if (result) {
          this.getPendingWorkflows();

          this.loading.set(false);
        }
      });
  }

  onAction(event: { action: string; row: any }) {

    switch (event.action) {

      case 'publish':
        this.openPublishConfirmation(event.row);
        break;

      case 'enable':
        this.enableWorkflow(event.row);
        break;

      case 'disable':
        this.openDisableConfirmationModal(event.row);
        break;

      case 'archive':
        this.openArchiveConfirmation(event.row);
        break;

      case 'restore':
        this.restoreWorkflow(event.row);
        break;

      case 'copy':
        this.startWorkflowCopy(event.row);
        break;

      case 'makePublic':
        this.toggleVisibleToPublic(event.row);
        break;

      case 'history':
        this.openWorkflowCheckpointsConfirmation(event.row);
        break;

      case 'start':
        this.startApplication(event.row);
        break;

      case 'resume':
        this.resumePendingWorkflow(event.row);
        break;

      case 'delete':
        this.openDeleteConfirmationModal(event.row);
        break;

      default:
        console.warn('Unknown action:', event.action);
    }
  }

  // added by Vipul on 27-03-2026
  onNameClick(row: any) {
    this.loading.set(true);
    this.workflowJanusService.setSelectedWorkflow(row.raw);

    this.workflowJanusService.setData({
      ...this.workflowJanusService.getData(),
      permissions: {
        disable: this.canDisable(row.raw),
        publish: this.canPublish(row.raw),
        history: this.canViewHistory(row.raw),
        builder: this.canEditWorkflow(row.raw),
        start: this.canStartApplication(),
        archive: this.canArchiveWorkflow(row.raw),
      }
    });
    if (this.activeTab === 'list') {
      this.workflowJanusService.setNewWorkflowButtonDisabled(true);
      this._router.navigate([{
        outlets: {listWorkflowSettings: [row.raw.id]},}],
        {
          relativeTo: this._route,
          state: { useNewLayout: this._context.useNewLayout}
        }
      ).then(() => {
        this.loading.set(false);
      }).catch(err => {
        console.error('Navigation error: ', err);
        this.loading.set(false);
      });
    } else if (this.activeTab === 'archive') {
      this.workflowJanusService.setNewWorkflowButtonDisabled(true);
      this._router.navigate([{
        outlets: {archiveWorkflowSettings: [row.raw.id]},}],
        {
          relativeTo: this._route,
          state: { useNewLayout: this._context.useNewLayout}
        }
      ).then(() => {
        this.loading.set(false);
      }).catch(err => {
        console.error('Navigation error: ', err);
        this.loading.set(false);
      });
    }
  }

  getWorkflowInputs = (row: any) => ({
    workflow: row.raw,
    disable: this.canDisable(row.raw),
    publish: this.canPublish(row.raw),
    history: this.canViewHistory(row.raw),
    builder: this.canEditWorkflow(row.raw),
    start: true,
    archive: this.canArchiveWorkflow(row.raw),

  });
  // added by Vipul on 27-03-2026

  buildAddJurisdictionDropdown(): void {
    this.jurisdictionData = {
      placeholder: 'Destination',
      options: [
        { label: 'Global', value: 'global', isHeader: true },

        { label: 'Template Library', value: 'templateLib' },

        { label: 'Jurisdictions', value: 'jur', isHeader: true },

        ...(this.clients || []).map(cl => ({
          label: cl.name,
          value: cl.id
        }))
      ]
    };
  }

  onJurisdictionSelected(event: any) {
    this.targetClientId1 = event; //added by Vipul on 04/19/2026
    this.buildAddJurisdictionDropdown();
  }

  onSearchChange(value: string) {
    this.searchText = value?.toLowerCase() || '';

    if (this.activeTab === 'list') {
      this.workflows$.subscribe(data => {
        this.filteredWorkflows = (data || []).filter(wf =>
          wf.name?.toLowerCase().includes(this.searchText)
        );
      });
    } else if (this.activeTab === 'archive') {
      this.archivedWorkflows$.subscribe(data => {
        this.filteredWorkflows = (data || []).filter(wf =>
          wf.name?.toLowerCase().includes(this.searchText)
        );
      });
    } else {
      this.pendingWorkflows$.subscribe(data => {
        this.filteredWorkflows = (data || []).filter(wf =>
          wf.sourceWorkflowName?.toLowerCase().includes(this.searchText)
        );
      });
    }
  }

  shouldUseFullHeight(data: any[] | null | undefined): boolean {
    return (data?.length || 0) <= 10;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.setTableHeight();
  }

  ngAfterViewInit(): void {
    this.setTableHeight();
  }

  private setTableHeight(): void {
    const screenHeight = window.innerHeight;

    const availableHeight = screenHeight - 280;

    this.tableHeight = `${Math.max(300, availableHeight)}px`;
  }

  private updateNewWorkflowButton(): void {

    const root = this._router.routerState.root;

    const hasOpenOutlet = this.hasActiveOutlet(root);

    this.workflowJanusService.setNewWorkflowButtonDisabled(hasOpenOutlet);
  }

  private hasActiveOutlet(route: ActivatedRoute): boolean {

    const disabledOutlets = [
      'modal',
      'listWorkflowSettings',
      'archiveWorkflowSettings',
      'editWorkflow',
      'appView'
    ];

    if (
      route.outlet &&
      disabledOutlets.includes(route.outlet) &&
      route.snapshot.url.length > 0
    ) {
      return true;
    }

    return route.children.some(child => this.hasActiveOutlet(child));
  }
}
